<template lang="html">
<div>
   <div class="table-box card-table" v-if="data.length > 0">
      <div class="clearfix search-box">
         <div class="title-box">
            <div class="title fx-h5">{{title}}</div>
         </div>
         <div class="form">
            <div class="input-group mg-b-10">
                  <input 
                     type="text" 
                     class="small form-control" 
                     placeholder="Search" 
                     aria-label="Search" 
                     v-model="query"
                     aria-describedby="basic-addon2" 
                     @keyup="search()">
                  <div class="input-group-append">
                     <span class="input-group-text" id="basic-addon2"><i class="fa fa-search"></i></span>
                  </div>
            </div>
         </div>
      </div>
      
      <table class="table table-striped ml-table ml-responsive-md" :class="table_class">
         <thead>
            <slot name="thead" v-if="hasHead"></slot>
            <tr v-else>
               <th scope="col" 
                  v-for="(field,index) in table_fields"
                  :key="index"
                  :class="{'center': field.align === 'c','right' : field.align === 'r'}">
                     {{field.name}}
               </th>
            </tr>
         </thead>
         <tbody>
            <slot name="tbody" v-if="hasBody"></slot>
            <tr v-for="(d,index) in data" :key="index" v-else-if="!hasBody && row_data.length === table_fields.length">
               <td 
                  v-for="(i,index) in row_data.length" 
                  :key="index"
                  :data-label="table_fields[i-1].name"
               >
                  <span v-show="false">{{i -= 1}}</span>
                  <!-- Images -->
                  <div v-if="row_data[i].type === 'image'"
                     class="profile-img" 
                     :class="row_data[i].class">
                        <img :src="`${d[row_data[i].domain] || ''}${d[row_data[i].field]}`" class="tbl-img" alt="">
                  </div>
                  
                  <!-- Single field text -->
                  <div v-if="row_data[i].type === 'text'" 
                     class="bigger mt-2" 
                     :class="row_data[i].class">
                        {{getNestedObject(d,row_data[i].field.split('.')) || '-' }}
                  </div>

                  <!-- Single field text -->
                  <div v-if="row_data[i].type === 'number'" 
                     class="bigger mt-2" 
                     :class="row_data[i].class">
                        {{utils.numberWithCommas(Math.round(Number(d[row_data[i].field])*100) / 100)}}
                  </div>

                  <!-- Nested field text -->
                  <div v-if="row_data[i].type === 'nested'" :class="row_data[i].class">
                     <div v-for="(row,index) in row_data[i].rows" :key="index" :class="row_data[i].class">
                        <span :class="row.class">{{d[row.field] || '-'}}</span>
                     </div>
                  </div>

                  <!-- Status -->
                  <div 
                     class="txt-primary status small bolder" 
                     v-if="row_data[i].type === 'status'" 
                     :class="row_data[i].class">
                        <i class="fa fa-circle"></i> 
                        <span>{{d[row_data[i].field] || 'Active'}}</span>
                  </div> 

                  <!-- Date -->
                  <div v-if="row_data[i].type === 'date'" 
                     class="bold small mt-2" 
                     :class="row_data[i].class">
                        {{moment(d[row_data[i].field]).format(row_data[i].format)}}
                  </div>
                  
                  <Dropdown 
                     class="fx-dropdown"
                     v-if="row_data[i].type === 'action'" 
                     :class="row_data[i].class"
                     trigger="click"
                     @on-click="clickAction($event,d)"
                  >
                     <a class="btn-action" href="javascript:void(0)">
                        <i class="fa fa-chevron-circle-down"></i>
                     </a>
                     <DropdownMenu slot="list">
                        <DropdownItem 
                           v-for="(action,index) in row_data[i].actions" 
                           :key="index"
                           :name="action.event"
                        >
                           <div class="clearfix" v-if="action.type === 'menu'">
                              <i class="fa" :class="action.icon || 'fa-eye'"></i> 
                              <div class="menu-text">{{action.title}}</div> 
                           </div>

                           <span v-if="action.type === 'title'">{{action.title}}</span>
                        </DropdownItem>
                     </DropdownMenu>
                  </Dropdown>
               </td>
            </tr>
            <tr v-else-if="!hasBody && row_data.length !== table_fields.length">
               <td><h5 style>The title fields and row fields do not match</h5 style></td>
            </tr>
         </tbody>
      </table>

      <Pagination :total="total" :current="current" @on-change="changePage" show-total/>
   </div>

   <div class="dotted-border" v-if="data.length === 0" @click="onEmptyAction()">
      <div class="row justify-content-md-center">
         <div class="col-12 col-md-11 col-lg-10 col-xl-9 action-card">
            <div class="btn btn-transparent btn-primary btn-round"><div :class="icon"></div></div>
            <div class="title">{{title}}</div>
            <div class="subtitle">
               No data found! <span v-show="hasAction">Click <span class="link">Here</span> to add {{title}}</span>
            </div>
         </div>
      </div>
   </div>
</div>
</template>

<script>
import PageStore from './pagestore'
import {directive as clickOutside} from 'v-click-outside-x';

export default {
   components:{
      Pagination: () => import("../pagination"),
      Dropdown: () => import("../dropdown/dropdown"),
      DropdownItem: () => import("../dropdown/dropdown-item"),
      DropdownMenu: () => import("../dropdown/dropdown-menu"),
   },
   directives: { clickOutside },
   props: {
		icon: {
			default: 'fa fa-satellite-dish'
		},
		hasHead: {
			default: false
		},
		hasBody: {
			default: false
		},
		hasAction: {
			default: false
		},
		table_fields: {
			default: function(){
            return []
         }
		},
		table_data: {
			default: function(){
            return []
         }
      },
		row_data: {
			default: function(){
            return []
         }
      },
      search_fields: {
         default: function(){
            return []
         }
      },
      title: {
         default: 'Table Title'
      },
      table_class: {
         default: ''
      }
   },
   watch: {
      table_data: function(){
         this.initializeData()
      }
   },
	data() {
		return {
         data: [],
			utils,
			moment,
			total: 0,
			current: 1,
         store: null,
         hasRendered: false,
         query: "",
         dropVisible: false
		};
	},
	methods: {
      getNestedObject(nestedObj, pathArr) {
         return pathArr.reduce((obj, key) =>
            (obj && obj[key] !== 'undefined') ? obj[key] : undefined, nestedObj);
      },
      initializeData(){
         this.data = this.table_data

         if(this.data.length > 0){
            this.store = new PageStore(this.data);
            this.data = this.store.paginateRecords(10);
            this.total = this.store.getTotalRecords();
            this.$emit('data-change',this.data)
         }

      },
      closeDropdown(){
         this.dropVisible = false
      },
      toggleDropdown(){
         this.dropVisible = !this.dropVisible
      },
      clickAction(action,row){
         this.$emit('on-action',{action,row})
      },
		changePage(p) {
         if(this.data.length > 0){
            this.data = this.store.getPage(p);
            this.$emit('data-change',this.data)
         }
		},
		search() {
         if(this.data.length > 0 && this.search_fields.length > 0){
            this.data = this.store.searchRecords(this.search_fields,this.query);
            this.current = this.store.getCurrent();
            this.total = this.store.getTotalRecords();
            this.$emit('data-change',this.data)
         }
      },
      onEmptyAction(){
         this.$emit('on-empty',{})
      }
	},
	async mounted() {
      this.initializeData()

      if(this.data.length > 0){
         this.store = new PageStore(this.data);
         this.data = this.store.paginateRecords(10);
         this.total = this.store.getTotalRecords();
      }
	}
};
</script>

<style lang="scss">

</style>